// extracted by mini-css-extract-plugin
module.exports = {"container":"i_GN","inputs-container":"i_GO"};